module.exports = __webpack_public_path__ + "static/media/printer.23c839e9.svg";